import { FormInput } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import { Box } from 'rebass/styled-components';
import MultiSelect from './components/multiSelect';

export const options = [
  {
    id: 1,
    label: 'Yes, subscribe me',
    description: 'Send me alerts for new jobs matching my preferences (one daily email max).',
    value: 'yes',
  },
  {
    id: 2,
    label: 'Not now',
    description: 'No daily emails, but please get in touch directly if a company wants to connect with me.',
    value: 'no',
  },
];

export const WorkAlert = ({ onChange, data, variant }) => {
  const alertOptions = [
    {
      ...options[0],
      children:
        data.value.value === 'yes' ? (
          <Formik initialValues={{ keywords: data.keywords }}>
            {() => (
              <Form data-testid="alert-form">
                <Box mt="16px" sx={{ 'label + div': { color: 'text.main' } }}>
                  <Field
                    name="keywords"
                    type="text"
                    component={FormInput}
                    label="Job alerts keywords"
                    helpText="Add one or more keywords to receive an email about new open jobs (alerts will also consider your profile information)."
                    required
                    placeholder="E.g. “Marketing”, “Front end” or “UX/UI”"
                    value={data.keywords}
                    onChange={({ target }) => onChange('alert', { ...data, keywords: target.value })}
                  />
                </Box>
              </Form>
            )}
          </Formik>
        ) : null,
    },
    options[1],
  ];

  return (
    <>
      <MultiSelect
        initialData={data.value}
        onChange={(alert) => onChange('alert', { ...data, value: alert })}
        options={alertOptions}
        type="radio"
        variant={variant}
      />
    </>
  );
};

WorkAlert.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

WorkAlert.defaultProps = {
  variant: 'onboarding',
};

export default WorkAlert;
